import O1HD from "../../engines/gameEngine";
import spendGameManager from "./manager/spendGameManager";
import NpcObj from "./NpcObj";
import PlotStartDialog from "./prefab/PlotStartDialog";
import DreamHousePrefab from "./prefab/DreamHousePrefab";
import spendEventShow from "./page/spendEventShow";
import getOneSpendEventById from "./config/SpendEventConfig";
import DayRecordPrefab from "./prefab/dialog/DayRecordPrefab";
import getOneSpendEmergencyEventById from "./config/SpendEmergencyConfig";
import data_control from "../../engines/libs/data_control";

const {ccclass, property} = cc._decorator;

@ccclass
export default class spendMode extends cc.Component {

    static _instance : spendMode = null;

    manage:spendGameManager = null;

    @property({type:cc.Node,displayName:"游戏节点"})
    gameNode:cc.Node = null;

    @property({type:cc.Node,displayName:"房子大节点"})
    houseNode:cc.Node = null;

    @property({type:cc.Node,displayName:"下一天按钮"})
    nextBtn:cc.Node = null;
    @property({type:cc.Node,displayName:"uiNode"})
    uiNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"剧情开始预制体"})
    plotStartPrefab : cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"圆梦House"})
    dreamHousePrefab : cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"日报告预制体"})
    dayRecordPrefab : cc.Prefab = null;

    @property({type:cc.Label,displayName:"天数"})
    daysLb : cc.Label = null;

    maxX:number = 0;
    minX:number = 0;

    static canClick : boolean = true;

    onLoad(){
        spendMode._instance = this;
        this.manage = new spendGameManager( this );
        this.gameNode.on("touchmove" , this.onTouchGameNodeMove , this );
        this.manage.loadEventConfig();

        this.daysLb.string = `第${(this.manage.getGameData()._gameDays+1)}天`;
        // this.openOneEmergencyEvent("2");

    }

    start(){
        O1HD.getManagers().soundMgr.playMusic("bg2");
        cc.systemEvent.on( cc.game.EVENT_SHOW , ()=>{
            O1HD.getManagers().soundMgr.playMusic("bg2");
        });
        this.maxX = ( this.gameNode.width / 2 ) - ( O1HD.Canvas().width / 2 );
        this.minX = ( O1HD.Canvas().width / 2 ) - ( this.gameNode.width / 2 );
        //如果 刚开始，开启剧情介绍
        if ( this.manage.getGameData()._gameDays == 0 && this.manage.getGameData()._currentCostMoney <= this.manage.getGameData()._currentDayTargetMoney ) {
            this.manage.getGameData()._currentDayTargetMoney = this.manage.NEED_COST_COINS_ARRAY[0];
            let plotStartPrefabNode =  cc.instantiate( this.plotStartPrefab );
            plotStartPrefabNode.getComponent( PlotStartDialog ).bindData( this );
            this.uiNode.addChild( plotStartPrefabNode );
        }
        this.showLog();
    }

    //展示 日报
    showLog(){
        if ( this.manage.getGameData()._logShowFlag ) {
            let dayRecordPrefabNode = cc.instantiate( this.dayRecordPrefab );
            this.node.addChild( dayRecordPrefabNode );
            dayRecordPrefabNode.getComponent( DayRecordPrefab ).bindData( this.manage ,()=>{
                spendMode._instance.checkOneEmergencyEvent();
            });
            this.manage.setGameData({_logShowFlag : false } , false );
        }
    }

    /**
     * 打开 圆梦 house
     */
    onBtnOpenDreamHouse(){
        let dreamHousePrefabNode = cc.instantiate( this.dreamHousePrefab );
        this.uiNode.addChild( dreamHousePrefabNode );
        dreamHousePrefabNode.getComponent( DreamHousePrefab ).bindData( this.manage );
    }

    onBtnNextDay(){
        if(this.manage.checkCanNextDay()){
            this.manage.jumpToNextDay();
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("当天花钱任务还未完成" , this.node );
            // utilsModel.loadAndShowVideoAdTrans(()=>{
            //     this.manage.jumpToNextDay();
            // },()=>{
            //
            // },null,"看广告切天");
        }
    }

    onTouchGameNodeMove(e:cc.Event.EventTouch){
        let detal:cc.Vec2 = e.getDelta();
        let gx:number = this.gameNode.x + detal.x;
        if(gx > this.maxX) gx = this.maxX;
        if(gx < this.minX) gx = this.minX;
        this.gameNode.x = gx;
    }

    /**
     *
     */
    moveToDreamHome(){
        //镜头移动
        cc.tween( this.gameNode )
            .to( 0.5,{ x : this.maxX })
            .call(()=>{
                this.scheduleOnce(()=>{
                    let dreamHousePrefabNode = cc.instantiate( this.dreamHousePrefab );
                    this.uiNode.addChild( dreamHousePrefabNode );
                    dreamHousePrefabNode.getComponent( DreamHousePrefab ).bindData( this.manage );
                },1);
            })
            .start();
        //打开圆梦预制体

    }

    //更新升级过的房子
    updateUpGradeHouse(){
        let Grades:string[] = this.manage.getGameData()._npcGradeArray;
        this.houseNode.children.forEach((n:cc.Node)=>{
            let ns = n.getComponent(NpcObj);
            let name:string = ns.name;
            if(Grades.includes(name)){
                ns.upGrade();
            }else{
                ns.normal();
            }
        });
    }

    @property({type:cc.Prefab,displayName:"事件弹窗"})
    eventPrefab:cc.Prefab = null;

    openOneEvent(eventId:string,complete?:( eventEnd : number )=>void){
        let event = getOneSpendEventById(eventId);
        let prefab:cc.Node = cc.instantiate(this.eventPrefab);
        let ps = prefab.getComponent(spendEventShow);
        ps.bindEvent(event, this.manage ,complete );
        this.uiNode.addChild(prefab);
    }

    openOneEmergencyEvent(eventId:string,complete?:( eventEnd : number )=>void){
        let event = getOneSpendEmergencyEventById(eventId);
        let prefab:cc.Node = cc.instantiate(this.eventPrefab);
        let ps = prefab.getComponent(spendEventShow);
        ps.bindEvent(event, this.manage ,complete );
        this.uiNode.addChild(prefab);
    }

    //新加一个npc
    addOneNpc(npc:string){
        this.houseNode.children.forEach((n:cc.Node)=>{
            let ns = n.getComponent(NpcObj);
            ns.addOneNpc(npc);
        })
    }

    //更新所有房子的所有npc
    updateNpcs(){
        this.houseNode.children.forEach((n:cc.Node)=>{
            let ns = n.getComponent(NpcObj);
            ns.updateDialog();
        });
    }

    emergencyEventAryDays:number[] = [4,6,7];

    emergencyEventAry:string[] = ["1","2"];

    emergencyEventAriseAry:string[] = [];

    checkOneEmergencyEvent(){
        if(this.emergencyEventAryDays.includes(this.manage.getGameData()._gameDays)){
            let event = data_control.getRandItemOfArray(this.emergencyEventAry);
            let randCount:number = 0;
            while(this.emergencyEventAriseAry.includes(event)){
                if(randCount > 100) break;
                event = data_control.getRandItemOfArray(this.emergencyEventAry);
                randCount ++;
            }
            this.openOneEmergencyEvent(event);
        }
    }

}
